interface Props {
	slice: any
}

export default function ThreeWidgets({ slice }: Props) {
	const { primary, items } = slice

	return (
		<section className="relative py-16 lg:py-20 three-widgets">
			{/* Background color */}
			<div
				className="absolute inset-x-0 bottom-0 bg-gray-150 top-0 -z-20 lg:-translate-y-56"
				aria-hidden="true"
			/>

			{primary?.section_title?.[0]?.text && (
				<h2 className="title text-4xl text-center mb-10">
					{primary.section_title[0].text}
				</h2>
			)}

			<div className="container flex max-lg:items-center max-lg:flex-col max-lg:gap-y-10 lg:gap-x-16 xl:gap-x-20 lg:justify-between">
				{items.map((widget: any, i: any) => {
					let cardBackgroundColor
					let cardSubtitleColor

					if (i === 0) {
						cardBackgroundColor = 'bg-bbx-crystal'
						cardSubtitleColor = 'text-bbx-style'
					} else if (i === 1) {
						cardBackgroundColor = 'bg-bbx-glow'
						cardSubtitleColor = 'text-white'
					} else {
						cardBackgroundColor = 'bg-bbx-style'
						cardSubtitleColor = 'text-bbx-pearl'
					}
					return (
						<div
							className="bg-white shadow-bbx-xl max-w-[320px]"
							// eslint-disable-next-line react/no-array-index-key
							key={i}
						>
							{/* Card title */}
							{widget?.section_card_title?.[0]?.text && (
								<div className={`py-9 px-10 relative ${cardBackgroundColor}`}>
									{/* A11Y: font-bold qualifies as large text (14pt+ bold) requiring only 3:1 contrast ratio */}
								<h3 className={`text-xl font-bold md:text-2xl ${cardSubtitleColor}`}>
										{widget.section_card_title[0].text}
									</h3>

									{/* Right side shadow */}
									<div className="absolute inset-y-0 right-0 w-5 bg-bbx-style/10" aria-hidden="true" />
								</div>
							)}

							<div className="px-8 pt-12 mt-auto pb-14 lg:pb-10 lg:pl-10 lg:pt-9">
								{/* Card section subtitle */}
								{widget.section_box_subtitle?.[0]?.text && (
									<h4 className={`mb-1 ${cardSubtitleColor}`}>
										{widget.section_box_subtitle[0].text}
									</h4>
								)}

								{/* Card section title */}
								{widget.section_box_title?.[0]?.text && (
									<h3 className="text-2xl font-medium md:text-3xl">
										{widget.section_box_title[0].text}
									</h3>
								)}

								{/* Card section description */}
								{widget.section_box_description?.[0] && (
									<p className="mt-4 font-light max-md:text-sm">
										{widget.section_box_description[0].text}
									</p>
								)}
							</div>
						</div>
					)
				})}
			</div>
		</section>
	)
}
